// src/pages/NewsDetail.js
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import '../styles/NewsDetail.css';
import newsData from '../data/news.json';
const NewsDetail = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [article, setArticle] = useState(null);

    useEffect(() => {
        const articleId = parseInt(id);
        const foundArticle = newsData.find(item => item.id === articleId);
        setArticle(foundArticle);
    }, [id]);

    if (!article) {
        return (
            <div className="news-detail">
                <p>Article non trouvé.</p>
                <button className="back-button" onClick={() => navigate(-1)}>
                    ← Retour aux actualités
                </button>
            </div>
        );
    }

    return (
        <div className="news-detail">
            <motion.div
                className="news-detail-card"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
            >
                <div className="detail-image">
                    <img src={article.image} alt={article.title} />
                    <span className="detail-category">{article.category}</span>
                </div>
                <div className="detail-content">
                    <h1>{article.title}</h1>
                    <div className="detail-meta">
                        <time>{new Date(article.date).toLocaleDateString('fr-FR')}</time>
                    </div>
                      {article.content.split('\n\n').map((section, sectionIndex) => {
    if (section.trim().startsWith('- ')) {
      // Convertir la liste en <ul><li>
      const listItems = section.split('- ').filter(item => item.trim() !== '').map((item, itemIndex) => (
        <li key={itemIndex}>{item.trim()}</li>
      ));
      return <ul key={sectionIndex} className="detail-list">{listItems}</ul>;
    } else {
      return <p key={sectionIndex} className="detail-text">{section}</p>;
    }
  })}

                    <p className="detail-text">Source : <a href={article.source} target = '_blanc'>{article.source}</a></p>
                    <button className="back-button" onClick={() => navigate(-1)}>
                        ← Retour aux actualités
                    </button>
                </div>
            </motion.div>
        </div>
    );
};

export default NewsDetail;
